import { Component, OnInit } from "@angular/core";
import { logbaseService } from "../../services/logbase.service";
import { NgxSpinnerService } from "ngx-spinner";
//import { forEach } from "@angular/router";

@Component({
  selector: "app-l4kpi",
  templateUrl: "./l4kpi.component.html",
  styleUrls: ["./l4kpi.component.scss"]
})
export class L4kpiComponent implements OnInit {
  public thirdChartData: any[];
  public xAxisCategoriessmvs: any[];

  public smqChartData: any[];
  public xAxisCategoriessmq: any[];
  public logisticChartData: any[];
  public xAxisCategorieslogistic: any[];

  public operationChartData: any[];
  public xAxisCategoriesoperation: any[];
  completeResponse: any;

  resactivePackagingRequest: any;
  suppCode: any;
  suppCodeList: any;
  suppCodeVal: any;
  userRoleID: any;
  constructor(
    private logbaseService: logbaseService,
    private spinner: NgxSpinnerService
  ) {}
  public activepackagebarChartData: any[] = [{ data: [], label: "" }];
  public barChartType: string = "bar";
  public barChartLegend: boolean = true;
  public lineChartColors: Array<any> = [
    {
      // First
      backgroundColor: "#004355",
      borderColor: "rgba(148,159,177,1)",
      pointBackgroundColor: "rgba(148,159,177,1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(148,159,177,0.8)"
    },
    {
      // Second
      backgroundColor: "#00677E",
      borderColor: "rgba(77,83,96,1)",
      pointBackgroundColor: "rgba(77,83,96,1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(77,83,96,1)"
    },
    {
      // Third
      backgroundColor: "#007892",
      borderColor: "rgba(148,159,177,1)",
      pointBackgroundColor: "rgba(148,159,177,1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(148,159,177,0.8)"
    },
    {
      // Fourth
      backgroundColor: "#0787A5",
      borderColor: "rgba(148,159,177,1)",
      pointBackgroundColor: "rgba(148,159,177,1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(148,159,177,0.8)"
    },
    {
      // Fifth Top
      backgroundColor: "#A7C9D8",
      borderColor: "rgba(148,159,177,1)",
      pointBackgroundColor: "rgba(148,159,177,1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(148,159,177,0.8)"
    },
    {
      // Sixth Top
      backgroundColor: "#440E07",
      borderColor: "rgba(148,159,177,1)",
      pointBackgroundColor: "rgba(148,159,177,1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(148,159,177,0.8)"
    }
  ];
  chartOpt = {
    scaleShowVerticalLines: false,
    responsive: true,
    legend: { position: "bottom" },
    scales: {
      xAxes: [
        {
          stacked: true,
          gridLines: {
            drawOnChartArea: false
          }
        }
      ],
      yAxes: [
        {
          stacked: true,
          gridLines: {
            drawOnChartArea: false
          }
        }
      ]
    }
  };
  ngOnInit() {
    this.spinner.show();
    let userDetails = localStorage.getItem("userDetails");
    let userDetJson = JSON.parse(userDetails);
    this.userRoleID = userDetJson.loginId;
    this.logbaseService
      .getKPIL4DataonLoad(this.userRoleID)
      .subscribe(result => {
        this.completeResponse = result;

        var smvsweek1Data = [];
        var smvsweek2Data = [];
        var smvsweek3Data = [];
        var smvsweek4Data = [];
        var smvsremainingData = [];
        var smvsdelayedData = [];
        var axisCategoriessmvs = [];
        if (this.completeResponse.response.SMVS) {
          this.completeResponse.response.SMVS.forEach(function(value, key) {
            axisCategoriessmvs.push(value.loginId);
            smvsweek1Data.push(value.week1Count);
            smvsweek2Data.push(value.week2Count);
            smvsweek3Data.push(value.week3Count);
            smvsweek4Data.push(value.week4Count);
            smvsdelayedData.push(value.delayed);
            smvsremainingData.push(value.lessThanAweekCount);
          });
          this.xAxisCategoriessmvs = axisCategoriessmvs;
          this.thirdChartData = [
            { data: smvsweek1Data, label: "1 Week until approval deadline" },
            { data: smvsweek2Data, label: "2 Week until approval deadline" },
            { data: smvsweek3Data, label: "3 Week until approval deadline" },
            { data: smvsweek4Data, label: "4 Week until approval deadline" },
            { data: smvsremainingData, label: "Remaining Week" },
            { data: smvsdelayedData, label: "Delayed Data" }
          ];
        }
        var smqweek1Data = [];
        var smqweek2Data = [];
        var smqweek3Data = [];
        var smqweek4Data = [];
        var smqremainingData = [];
        var smqdelayedData = [];
        var axisCategoriessmq = [];
        if (this.completeResponse.response.SMQ) {
          this.completeResponse.response.SMQ.forEach(function(value, key) {
            axisCategoriessmq.push(value.loginId);
            smqweek1Data.push(value.week1Count);
            smqweek2Data.push(value.week2Count);
            smqweek3Data.push(value.week3Count);
            smqweek4Data.push(value.week4Count);
            smqdelayedData.push(value.delayed);
            smqremainingData.push(value.lessThanAweekCount);
          });
          this.xAxisCategoriessmq = axisCategoriessmq;
          this.smqChartData = [
            { data: smqweek1Data, label: "1 Week until approval deadline" },
            { data: smqweek2Data, label: "2 Week until approval deadline" },
            { data: smqweek3Data, label: "3 Week until approval deadline" },
            { data: smqweek4Data, label: "4 Week until approval deadline" },
            { data: smqremainingData, label: "Remaining Week" },
            { data: smqdelayedData, label: "Delayed Data" }
          ];
        }
        var logisticweek1Data = [];
        var logisticweek2Data = [];
        var logisticweek3Data = [];
        var logisticweek4Data = [];
        var logisticremainingData = [];
        var logisticdelayedData = [];
        var axisCategorieslogistic = [];
        if (this.completeResponse.response.LOGISTIC) {
          this.completeResponse.response.LOGISTIC.forEach(function(value, key) {
            axisCategorieslogistic.push(value.loginId);
            logisticweek1Data.push(value.week1Count);
            logisticweek2Data.push(value.week2Count);
            logisticweek3Data.push(value.week3Count);
            logisticweek4Data.push(value.week4Count);
            logisticdelayedData.push(value.delayed);
            logisticremainingData.push(value.lessThanAweekCount);
          });
          this.xAxisCategorieslogistic = axisCategorieslogistic;
          this.logisticChartData = [
            {
              data: logisticweek1Data,
              label: "1 Week until approval deadline"
            },
            {
              data: logisticweek2Data,
              label: "2 Week until approval deadline"
            },
            {
              data: logisticweek3Data,
              label: "3 Week until approval deadline"
            },
            {
              data: logisticweek4Data,
              label: "4 Week until approval deadline"
            },
            { data: logisticremainingData, label: "Remaining Week" },
            { data: logisticdelayedData, label: "Delayed Data" }
          ];
        }

        var operationweek1Data = [];
        var operationweek2Data = [];
        var operationweek3Data = [];
        var operationweek4Data = [];
        var operationremainingData = [];
        var operationdelayedData = [];
        var axisCategoriesoperation = [];
        if (this.completeResponse.response.OP) {
          this.completeResponse.response.OP.forEach(function(value, key) {
            axisCategoriesoperation.push(value.loginId);
            operationweek1Data.push(value.week1Count);
            operationweek2Data.push(value.week2Count);
            operationweek3Data.push(value.week3Count);
            operationweek4Data.push(value.week4Count);
            operationdelayedData.push(value.delayed);
            operationremainingData.push(value.lessThanAweekCount);
          });
          this.xAxisCategoriesoperation = axisCategoriesoperation;
          this.operationChartData = [
            {
              data: operationweek1Data,
              label: "1 Week until approval deadline "
            },
            {
              data: operationweek2Data,
              label: "2 Week until approval deadline "
            },
            {
              data: operationweek3Data,
              label: "3 Week until approval deadline "
            },
            {
              data: operationweek4Data,
              label: "4 Week until approval deadline "
            },
            { data: operationremainingData, label: "Remaining Week" },
            { data: operationdelayedData, label: "Delayed" }
          ];
        }
        this.spinner.hide();
      });
  }
}
